/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
export var GetBestRate = createPlugin({
    protocol: 'CURVE',
    type: 'GETTER',
    method: 'get_best_rate',
    description: 'Get the best rate for a token exchange on Curve Finance',
    supportedContracts: [{ address: '0x55B916Ce078eA594c10a874ba67eCc3d62e29822', chainId: 1 }],
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_exchange' }),
            methodParams: {
                from: new FctAddress({ destination: 'erc20' }),
                to: new FctAddress({ destination: 'erc20' }),
                amount: new FctValue({ destination: 'wei_amount' }),
            },
        },
        output: {
            poolAddress: new FctAddress({ innerIndex: 0, destination: 'curve_pool' }),
            expectedAmount: new FctValue({ innerIndex: 1, destination: 'wei_amount' }),
        },
    }); },
});
